<template>
  <div ref="whole-page">
    <router-view />
  </div>
</template>
<script>
import { removeToken } from "@/utils/auth";
import NavHeader from '@/components/NavHeader'

export default {
  components: { NavHeader },
  created() {
    let check = window.localStorage.getItem('uid') || window.sessionStorage.getItem('uid')
    console.log(check)
    if (!check) {
      removeToken()
    }
  }
}
</script>
<style>
html {
  font-size: 12px;
  word-spacing: 1px;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
}

*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
}

.button--green {
  display: inline-block;
  border-radius: 4px;
  border: 1px solid #3b8070;
  color: #3b8070;
  text-decoration: none;
  padding: 10px 30px;
}

.button--green:hover {
  color: #fff;
  background-color: #3b8070;
}

.button--grey {
  display: inline-block;
  border-radius: 4px;
  border: 1px solid #35495e;
  color: #35495e;
  text-decoration: none;
  padding: 10px 30px;
  margin-left: 15px;
}

.button--grey:hover {
  color: #fff;
  background-color: #35495e;
}
</style>